
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export interface BlogCardProps {
  title: string;
  excerpt: string;
  date: string;
  author: {
    name: string;
    avatar?: string;
    bio?: string;
  };
  slug: string;
  image?: string;
  authorImage?: string;
  coverImage?: string;
  category?: string;
  readTime?: string;
  featured?: boolean;
}

const BlogCard: React.FC<BlogCardProps> = ({
  title,
  excerpt,
  date,
  author,
  slug,
  image,
  authorImage
}) => {
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Link 
      to={`/blog/${slug}`}
      className="block h-full transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="glass-card h-full flex flex-col overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
        {/* Image container with consistent aspect ratio */}
        <div className="relative w-full pt-[56.25%] overflow-hidden bg-gray-100">
          {image ? (
            <img 
              src={image} 
              alt={title} 
              className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          ) : (
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-brand-navy to-brand-blue/70"></div>
          )}
        </div>
        
        <div className="p-5 flex-grow flex flex-col justify-between">
          <div>
            <h3 className="text-xl font-bold mb-2 line-clamp-2">{title}</h3>
            <p className="text-gray-600 mb-4 text-sm line-clamp-3">{excerpt}</p>
          </div>
          
          <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
            <div className="flex items-center">
              <div className="flex-shrink-0 w-8 h-8 rounded-full overflow-hidden bg-gray-200 mr-2">
                {authorImage || author.avatar ? (
                  <img src={authorImage || author.avatar} alt={author.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-brand-teal to-brand-blue flex items-center justify-center">
                    <span className="text-white text-xs font-bold">{author.name.charAt(0)}</span>
                  </div>
                )}
              </div>
              <div className="text-xs">
                <div className="font-medium">{author.name}</div>
                <div className="text-gray-500">{formattedDate}</div>
              </div>
            </div>
            
            <div className="text-brand-teal">
              <ArrowRight className="h-4 w-4" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
